module.exports = __webpack_public_path__ + "img/topsmjt_bg.528f4707.png";